import axios from "@/utils/request.js";
import qs from "qs"
// 新增 边看边买 保存
const activitybuyAdd = (params) => axios({
    url: '/api/web-manager/live/activitybuy/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
  // 边看边买 换位
const activitybuyChangeOrder = (params) => axios({
    url: '/api/web-manager/live/activitybuy/changeorder',
    method: 'post',
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    data: params
  })
  // 边看边买 换位
const activitybuyTopChangeOrder = (params) => axios({
    url: '/api/web-manager/live/activitybuy/changetoporder',
    method: 'post',
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    data: params
  })
//  边看边买编辑
const activitybuyEdit = (params) => axios({
  url: '/api/web-manager/live/activitybuy/edit',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 边看边买 置顶
const activitybuyTop = (params) => axios({
  url: '/api/web-manager/live/activitybuy/top',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 边看边买 上架
const activitybuyPutonoff = (params) => axios({
  url: '/api/web-manager/live/activitybuy/putonoff',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 删除边看边买直播 支持批量
const activitybuyDelete = (params) => axios({
    url: '/api/web-manager/live/activitybuy/delete',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
})
  //边看边买详情
const activitybuyPreview = (params) => axios({
    url: '/api/web-manager/live/activitybuy/preview',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
})
// 边看边买列表
const activitybuyPage = (params) => axios.get('/api/web-manager/live/activitybuy/page', {
  params
})
export {
  activitybuyAdd,
  activitybuyChangeOrder,
  activitybuyPreview,
  activitybuyEdit,
  activitybuyDelete,
  activitybuyPage,
  activitybuyTopChangeOrder,
  activitybuyPutonoff,
  activitybuyTop,
}